function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgEmpregosENegocios = function SvgEmpregosENegocios(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.978.264l3.85.678-.932 5.283-3.85-.68.932-5.281zM7.794 1.742l3.581.631-.174.985-3.58-.631a.954.954 0 00-1.106.774L3.736 19.258a.954.954 0 00.774 1.106l11.46 2.02a.956.956 0 001.106-.774l2.773-15.757a.955.955 0 00-.774-1.106l-3.576-.631.174-.985 3.576.63a1.955 1.955 0 011.585 2.265L18.06 21.784a1.956 1.956 0 01-2.265 1.586l-11.46-2.021a1.954 1.954 0 01-1.584-2.265L5.53 3.327a1.954 1.954 0 012.264-1.585zm6.29 3.325l-1.88-.332.585-3.312 1.88.331-.584 3.313zm.461 12.823v1H8.727v-1h5.818zm-.59-7.444c0 .381-.092.74-.255 1.058a2.571 2.571 0 012.082 2.524v1.096c0 .706-.571 1.277-1.277 1.277H8.776A1.276 1.276 0 017.5 15.124v-1.096a2.57 2.57 0 012.073-2.523 2.318 2.318 0 114.381-1.059zm-2.319 2.319c-.42 0-.814-.112-1.154-.308h-.412a1.57 1.57 0 00-1.57 1.57v1.097c0 .153.124.277.276.277h5.73a.277.277 0 00.276-.277v-1.096a1.57 1.57 0 00-1.57-1.57h-.42c-.34.195-.735.307-1.156.307zm0-1a1.318 1.318 0 100-2.636 1.318 1.318 0 000 2.636z",
    fill: props.color
  }));
};
SvgEmpregosENegocios.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgEmpregosENegocios.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgEmpregosENegocios;